import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { Field } from "@/pages/auth/Login";
import { api, fmtErr } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [token, setToken] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setToken(data.reset_token || "");
      setDone(true);
    } catch (e2) { setDone(true); }
  };

  return (
    <AuthShell title="Forgot password" subtitle="We'll send you a reset link."
      footer={<Link to="/login" className="font-semibold text-primary">Back to login</Link>}>
      <Seo title="Forgot password" />
      {done ? (
        <div className="rounded-xl border border-border bg-card p-4 text-sm text-muted-foreground" data-testid="forgot-done">
          If an account exists for {email}, a reset link has been generated.
          {token && <div className="mt-3">Demo reset link: <Link className="font-mono text-primary underline" to={`/reset-password?token=${token}`}>Reset now</Link></div>}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="Email" type="email" value={email} onChange={setEmail} testid="forgot-email" />
          <button data-testid="forgot-submit" className="w-full rounded-xl bg-primary py-2.5 text-sm font-semibold text-primary-foreground">Send reset link</button>
        </form>
      )}
    </AuthShell>
  );
}
